/* tslint:disable */

declare var Object: any;
export interface SFPayrollInterface {
  "id"?: number;
}

export class SFPayroll implements SFPayrollInterface {
  "id": number;
  constructor(data?: SFPayrollInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPayroll`.
   */
  public static getModelName() {
    return "SFPayroll";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPayroll for dynamic purposes.
  **/
  public static factory(data: SFPayrollInterface): SFPayroll{
    return new SFPayroll(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPayroll',
      plural: 'SFPayrolls',
      path: 'SFPayrolls',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPayroll.ts